/* eslint-disable camelcase */
import { Component } from 'preact';
import PropTypes from 'prop-types';

export default class Item extends Component {
  constructor(props) {
    super(props);

    this.getSubtitle = this.getSubtitle.bind(this);
  }

  getLink() {
    const { part_link, slug } = this.props;
    return `${part_link}/${slug}`;
  }

  getTotalValueCall(itemOffer) {
    if (!itemOffer) return null;
    const { total_value } = itemOffer;

    if (total_value && total_value.secondary_call)
      return total_value.secondary_call;

    return null;
  }

  getMonthValueCall(itemOffer) {
    if (!itemOffer) return null;
    const { month_value } = itemOffer;

    if (month_value && month_value.secondary_call)
      return month_value.secondary_call;

    return null;
  }

  getTotalValue(itemOffer) {
    if (!itemOffer) return null;
    const { total_value } = itemOffer;

    if (total_value && total_value.featured) return total_value.featured;

    return null;
  }

  getMonthValue(itemOffer) {
    if (!itemOffer) return null;
    const { month_value } = itemOffer;

    if (month_value && month_value.featured) return month_value.featured;

    return null;
  }

  getInstallments(itemOffer) {
    if (!itemOffer) return null;
    const { month_value } = itemOffer;

    if (month_value && month_value.badge) return month_value.badge;

    return null;
  }

  getSubtitle() {
    const { subtitle, title } = this.props;
    const titleIsPresent = subtitle.search(title) > -1;

    if (titleIsPresent) return subtitle.replace(title, '');

    return subtitle;
  }

  getImageSrc() {
    const { side_profile_image, image } = this.props;

    if (side_profile_image.webp.url) return side_profile_image.webp.url;

    return image;
  }

  render() {
    const { title, item_offer } = this.props;
    const imgSrc = this.getImageSrc();
    const totalValueCall = this.getTotalValueCall(item_offer);
    const monthValueCall = this.getMonthValueCall(item_offer);
    const totalValue = this.getTotalValue(item_offer);
    const monthValue = this.getMonthValue(item_offer);
    const installments = this.getInstallments(item_offer);

    return (
      <div className="card card-consortia">
        <div className="card__header">
          <div className="card__header-background" />
          <p className="card__model-title">{title}</p>
          <p className="card__model-subtitle">{this.getSubtitle()}</p>

          {imgSrc && (
            <div className="card__img">
              <a href={this.getLink()}>
                <img
                  className="card__img-value"
                  src={imgSrc}
                  alt={title}
                  width={236}
                  height={105}
                />
              </a>
            </div>
          )}
        </div>

        <div className="card__content text-center">
          <div className="card__content-item">
            {totalValueCall ? (
              <div className="card__trigger-description card-consortia__card-trigger-description">
                {totalValueCall}
              </div>
            ) : null}

            {totalValue ? (
              <div className="card__trigger-value">{totalValue}</div>
            ) : null}
          </div>

          <div className="card__content-item">
            {monthValueCall ? (
              <div className="card__trigger-description card-consortia__card-trigger-description">
                {monthValueCall}
              </div>
            ) : null}

            {monthValue ? (
              <div className="card__trigger-month-value">{monthValue}</div>
            ) : null}

            {installments ? (
              <div className="badge badge--pill card-consortia__badge">
                {installments}
              </div>
            ) : null}
          </div>
        </div>

        <div className="card__footer">
          <a
            href={this.getLink()}
            className="card-consortia__button btn button button--block button--large card__cta"
          >
            Eu quero
          </a>
        </div>
      </div>
    );
  }
}

Item.propTypes = {
  side_profile_image: PropTypes.string,
  slug: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  part_link: PropTypes.string.isRequired,
  item_offer: PropTypes.shape({
    total_value: PropTypes.shape({
      secondary_call: PropTypes.string,
      featured: PropTypes.string,
    }),
    month_value: PropTypes.shape({
      secondary_call: PropTypes.string,
      featured: PropTypes.string,
      badge: PropTypes.string,
    }),
  }).isRequired,
};
